define('modules/editor/services/image_upload/index',['require','exports','module','../../views/editors/image_upload','common/models/appstate'],function(require, exports, module){
  "use strict";
  var ImageUploadView = require("../../views/editors/image_upload"),
      AppState = require("common/models/appstate");

  module.exports = {
    pageId: null,
    variantId: null,
    loadImage: function(currentUrl, callback){
      //parameters needed:
      //url (current image url, if exists)
      //pageId
      //variantId

      //returns if successful
      /*
      {
        url: image url
        id: image id
      }
      */
      var view = new ImageUploadView({
        pages_id: this.pageId,
        variants_id: this.variantId,
        platform: this.platform,
        url: currentUrl
      });
      AppState.setPropsPopUpOpen(true);

      view.once("modal:save", function(results){
        callback(results);
        AppState.setPropsPopUpOpen(false);
        // give some time to the image to completely load
        //_.delay(_.bind(view.hide, view), 100);
        view.hide();
      });
    }
  };
});

